import { Component, OnInit } from '@angular/core';
import { SuperAdminService } from 'src/app/services/apiCalls/superAdminService/super-admin.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';
import { UtilService } from 'src/app/services/utilService/util.service';

@Component({
  selector: 'app-settlement-history',
  templateUrl: './settlement-history.component.html',
  styleUrl: './settlement-history.component.css'
})
export class SettlementHistoryComponent implements OnInit{
  history: [] = [];
  breadCrumb:any;
  settlementDetails = [];
  settlementLines = [];
  settlementRef: string = '';
  statusId: number = 0;
  loadingHistory:boolean = false;
  changeOccured:boolean = true;
  hasChanged:boolean = true;
  ViewingSettlement:boolean = false;
  constructor(
    private superAdminService: SuperAdminService,
    private utileService: UtilService,
    private alertService: BootstrapNotifyService
  ){}
  currentPage: number = 1;
  perPage: number = 10;

  ngOnInit(): void {
    this.breadCrumb  = {
      name: 'Settlement History',
      parent: 'Home',
      subLink: null
    };
    this.settlementHistories();
  }

  settlementHistories(){
    this.loadingHistory = true;
    this.changeOccured = false;
    this.superAdminService.settlementHistory(this.currentPage, this.perPage).subscribe({
      next: (response)=>{
        this.history = response;
        this.utileService.startDatatable('all-state-zones')
        this.changeOccured = true;
      },
      error: (err)=>{
        this.changeOccured = true;
        this.alertService.error(err.error.message)
        this.utileService.startDatatable('all-state-zones')
      }
    }).add(()=> this.loadingHistory = false)
  }

  runSettlementHistory(payload:{transaction_ref: string}){
    this.superAdminService.runSettlement(payload).subscribe({
      next: (response)=>{
        this.settlementHistories();
      },
      error: (err)=>{
        this.alertService.error(err.error.message)
      }
    }).add(()=> {
      this.settlementRef = ''
    })
  }

  viewLines(line: any){
    const lineIndex = this.history.findIndex((line: any)=> line.transaction_ref ===  line.transaction_ref);
    if(lineIndex !== -1){
      this.utileService.openModal('lineModal');
      this.view(line.id);
    }
  }

  closeModal(){
    this.utileService.closeModal('lineModal');
  }

  viewSettlementDetails(id: string){
    this.ViewingSettlement = true;
    this.hasChanged = false;
    this.superAdminService.getSettlementDetails(id).subscribe({
      next: (response)=>{
        this.settlementLines = response.data;
        this.hasChanged = true;
        this.utileService.startDatatable('line')
      },
      error: (err)=>{
        this.hasChanged = true;
        this.utileService.startDatatable('line')
      }
    }).add(()=> this.ViewingSettlement = false)
  }

  refreshStatus(id: number){
    this.superAdminService.refreshStatus(id).subscribe({
      next:(res)=>{
        this.settlementHistories();
      },
      error:(err)=>{
        this.alertService.error(err.error.message);
      }
    }).add(()=> this.statusId = 0)
  }

  view(id: string){
    this.viewSettlementDetails(id);
  }

  SubmitForm(){}
}